import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/site';

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=old%20mysterious%20grocery%20shop%20facade%20at%20night%20with%20a%20glowing%20paper%20lantern%2C%20warm%20amber%20light%20spilling%20from%20the%20door%2C%20small%20round%20holes%20floating%20in%20the%20air%20like%20glowing%20bubbles%2C%20dusty%20nostalgic%20street%2C%20cream%20and%20terracotta%20and%20moss%20green%20palette%2C%20painterly%20magical%20illustration%2C%20cozy%20and%20mysterious&width=1600&height=860&seq=hero-zahuopu-2026&orientation=landscape"
          alt="洞洞杂货铺漫画大门在夜色中亮起暖光"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/40 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 pb-24 pt-40 text-center md:px-6 md:pb-28 md:pt-48">
        <span className="stamp rounded-full px-5 py-1.5 text-xs text-background-50">
          洞洞杂货铺漫画 · 设定科普站
        </span>
        <h1 className="mt-7 max-w-3xl text-3xl leading-snug text-background-50 md:text-5xl md:leading-snug">
          洞洞杂货铺漫画是什么？<br className="hidden md:block" />
          一本读懂这部独特漫画的完整设定
        </h1>
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-background-100/90 md:text-lg">
          {siteConfig.description}
        </p>
        <div className="mt-9 flex flex-col items-center gap-3 sm:flex-row">
          <Link
            to="/lore"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-400"
          >
            从世界观开始了解
            <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
          </Link>
          <a
            href="#hot"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200/70 bg-background-50/10 px-7 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            <i className="ri-fire-line text-sm" aria-hidden="true"></i>
            查看热门解读
          </a>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-sm text-background-100">
          <span className="inline-flex items-center gap-2">
            <i className="ri-hashtag text-base" aria-hidden="true"></i>6 篇深度设定
          </span>
          <span className="inline-flex items-center gap-2">
            <i className="ri-price-tag-3-line text-base" aria-hidden="true"></i>世界观 · 角色 · 故事
          </span>
          <span className="inline-flex items-center gap-2">
            <i className="ri-star-smile-line text-base" aria-hidden="true"></i>新手友好
          </span>
        </div>
      </div>
    </section>
  );
}